import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../services'
import { chatNotesQueryKey } from './useQueryChatNotes'

export function useMutationCreateChatNote(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: { title: string; content: string }) =>
			chatService.createChatNote(roomId, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatNotesQueryKey(roomId) })
			toast.success('สร้างโน้ตสำเร็จ')
		},
		onError: () => {
			toast.error('สร้างโน้ตล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}

export function useMutationUpdateChatNote(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			noteId,
			data,
		}: {
			noteId: string
			data: { title?: string; content?: string }
		}) => chatService.updateChatNote(noteId, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatNotesQueryKey(roomId) })
			toast.success('อัปเดตโน้ตสำเร็จ')
		},
		onError: () => {
			toast.error('อัปเดตโน้ตล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}

export function useMutationDeleteChatNote(roomId: string) {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (noteId: string) => chatService.deleteChatNote(noteId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatNotesQueryKey(roomId) })
			toast.success('ลบโน้ตสำเร็จ')
		},
		onError: () => {
			toast.error('ลบโน้ตล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
